var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V1.65329H22V0Z",
    fill: "#0D5EAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.65332H0V3.32135H22V1.65332Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.32129H0V4.98932H22V3.32129Z",
    fill: "#0D5EAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.99182H0V6.65985H22V4.99182Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.65979H0V8.32782H22V6.65979Z",
    fill: "#0D5EAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.32788H0V9.99591H22V8.32788Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.99585H0V11.6639H22V9.99585Z",
    fill: "#0D5EAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.6639H0V13.332H22V11.6639Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.332H0V15.0001H22V13.332Z",
    fill: "#0D5EAF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32738 0H0V8.32788H8.32738V0Z",
    fill: "#0D5EAF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32738 3.32129H0V4.98932H8.32738V3.32129Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99994 0H3.33203V8.57599H4.99994V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrc);
export default __webpack_public_path__ + "static/media/grc.abddfe523d6a65c9c6aa46e7a55cb779.svg";
export { ForwardRef as ReactComponent };